<template>
  <div class="text-center text-13 rounded-t-16 overflow-hidden pb-26 text-white">
    <Image :src="banner" class="w-full h-[187px]" alt="" >
      <template v-slot:loading>
        <van-loading type="spinner" size="20" />
      </template>
    </Image>

    <div class="p-4 leading-16">
      <p>{{ t('home.SideBar.LoginOrRegTips') }}</p>
      <p class="mt-1">{{ t('home.SideBar.LoginRestrictions') }}</p>

      <div class="flex justify-center h-8 gap-2.5 mt-4 text-15 font-[600]">
        <van-button class="primaryBtn_transparent-sm !w-24 !text-[var(--theme-primary)]" @click="$router.push('/login')">{{ t('LoginOrReg.Login') }}</van-button>
        <van-button class="primaryBtn-sm !w-24" @click="$router.push('/reg')">{{ t('LoginOrReg.Reg') }}</van-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { getLoginBanner } from '@/api/login'
  import { useSystemInfo } from '@/store'
  import i18n from "@/i18n";
  const t = i18n.global.t;
  const banner = ref('')
  const language = useSystemInfo().language
  getLoginBanner({ language }).then((res) => {
    const { code, data } = res
    if (code == 1 && data) {
      banner.value = data.picture
    }
  })
</script>

